import { Box, type BoxProps } from '@mui/material'
import { forwardRef } from 'react'
import { molsonUseTheme } from '@/theme/customMuiExports'

export type MolsonBoxProps = {
  dataTestId?: string
  boxShadowType?:
    | 'primaryLightBoldSelected'
    | 'default'
    | 'defaultBoldSelected'
    | 'defaultBoldUnselected'
    | 'none'
  borderRadiusType?: 'none' | 'defaultRounded'
} & BoxProps

export const MolsonBox = forwardRef<unknown, MolsonBoxProps>(
  (
    {
      dataTestId,
      boxShadowType = 'none',
      borderRadiusType = 'none',
      children,
      ...props
    },
    ref
  ) => {
    const theme = molsonUseTheme()
    const boxShadowStyle = () => {
      switch (boxShadowType) {
        case 'default':
          return '0px 2px 3px rgba(0,0,0,0.1)'
        case 'primaryLightBoldSelected':
          return `0px 3px 5px -1px ${theme.palette.primary.light}, 0px 5px 8px 0px ${theme.palette.primary.light}, 0px 1px 14px 0px ${theme.palette.primary.light}`
        case 'defaultBoldSelected':
          return '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
        case 'defaultBoldUnselected':
          return '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)'
        default:
          return 'none'
      }
    }

    const borderRadiusStyle = () => {
      switch (borderRadiusType) {
        case 'none':
          return 0
        case 'defaultRounded':
          return 3
      }
    }

    return (
      <Box
        ref={ref}
        data-testid={dataTestId}
        {...props}
        boxShadow={boxShadowStyle()}
        borderRadius={borderRadiusStyle()}
      >
        {children}
      </Box>
    )
  }
)

MolsonBox.displayName = 'MolsonBox'
